<script setup>
import { AVATAR_SIZES } from '@/utils/components-configurations/app-avatar'
import { ASSIGNEE_ENTITY_KEYS } from '@/utils/entity-keys'

import AppAvatar from '@/components/ui/AppAvatar/AppAvatar'

defineOptions({
  name: 'CheckinFeedAuthor'
})

defineProps({
  userData: {
    type: Object,
    default: () => ({})
  }
})
</script>

<template>
  <div class="cfa-Author">
    <AppAvatar
      :avatar-url="userData[ASSIGNEE_ENTITY_KEYS.AVATAR_URL]"
      :size="AVATAR_SIZES.LLG"
      class="cfa-Author_Avatar"
      no-margins
    />
    <div class="cfa-Author_Info">
      <span class="cfa-AuthorName oboard-truncated-text">
        {{ userData[ASSIGNEE_ENTITY_KEYS.NAME] }}
      </span>
      <div class="cfa-AuthorDate">
        <slot name="date" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cfa-Author {
  display: flex;
  align-items: center;
  gap: 10px;
}

.cfa-Author_Avatar {
  flex-shrink: 0;
}

.cfa-Author_Info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  line-height: 20px;
  overflow: hidden;
}

.cfa-AuthorName {
  color: $dark-1;
  font-size: $fs-14;
  line-height: 20px;
  font-weight: fw('semi-bold');
}

.cfa-AuthorDate {
  color: $dark-3;
  font-size: $fs-12;
}
</style>
